import { OffersListPageContent } from "@app/offers/pages";
import { getAllOffersService } from "@core/offers/services";
import { getRootSettings, pageHead } from "@framework/config/drivers/meta";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { publicRoutes } from "../../middleware";

export const loader = publicRoutes(async ({ http, success, queryString }) => {
  const response = await getAllOffersService(http, queryString.all());

  return success(response);
});

export default function OffersListPage() {
  const { offers } = useLoaderData<typeof loader>();

  return <OffersListPageContent offers={offers} />;
}

export const meta: MetaFunction = ({ matches }) => {
  const settings = getRootSettings(matches);

  return pageHead({
    title: "Offers",
    appendAppName: true,
    settings,
  });
};
